import styled from "styled-components";
import { SidebarLayoutShowMobile } from "../../layout/SideBarLayout";

export const ShowMoreLabel = styled.div`
    display: flex;
    align-items: center;

    &:hover { 
        cursor: pointer;
    }

    > div {
        margin-right: 10px;
        
        &:first-child {
            display: inline-flex;
        }
    }
`;

export const CSPMobileButtons = styled(SidebarLayoutShowMobile)`
    align-items: center;
        
    > div {
        &:first-child {
            margin-right: 18px;
        }
    }
`;